import authReducer from "./auth.slice";
import departmentReducer from "./department.slice";
import settingsReducer from "./settings.slice";
import staffReducer from "./staff.slice";
import projectReducer from './project.slice';
import billingCycleReducer  from "./billing-cycle.slice";
import vendorReducer  from "./vendor.slice";
import accountsReducer from "./accounts.slice";
import activityLogReducer from "./activity-log.slice";
import subDepartmentReducer from "./sub-department.slice";
import masterReducer from "./master.slice";

const allReducers = {
  auth: authReducer,
  settings: settingsReducer,
  staff: staffReducer,
  department: departmentReducer,
  subDepartment: subDepartmentReducer,
  project: projectReducer,
  billingCycle: billingCycleReducer,
  vendor: vendorReducer,
  account: accountsReducer,
  activityLog: activityLogReducer,
  master: masterReducer
};

export default allReducers;

